module.exports = __webpack_public_path__ + "muli-webfont.asset.88d7f8aadb77538b3e726ee3d2c5511c.woff";